// This file is generated by
// services/coaches/cmd/school_picker/generate_typescript.
// Do not edit directly.

// Map of ISO-3166-2 codes to the names of admin level one entities.
export const ADMIN_LEVEL_ONE_CODES_TO_NAMES: Record<string, string> = {
    "07": "TUYÊN QUANG",
    "26": "HUẾ",
    "44": "AN GIANG",
};

// Map of the administrative levels used in country.
//
// Keys are the ISO-3166-2 codes of the admin-level-one entities.
// Values are the names of the localities within those entities.
export const ADMIN_LEVELS: Record<string, string[]> = {
    "07": [
        "AN TƯỜNG",
        "BÌNH AN",
        "BÌNH CA",
        "BÌNH THUẬN",
        "BÌNH XA",
        "BẠCH NGỌC",
        "BẠCH XA",
        "BẠCH ĐÍCH",
        "BẢN MÁY",
        "BẮC MÊ",
        "BẮC QUANG",
        "BẰNG HÀNH",
        "BẰNG LANG",
        "CAO BỒ",
        "CHIÊM HOÁ",
        "CÁN TỶ",
        "CÔN LÔN",
        "DU GIÀ",
        "GIÁP TRUNG",
        "HOÀ AN",
        "HOÀNG SU PHÌ",
        "HÀ GIANG 1",
        "HÀ GIANG 2",
        "HÀM YÊN",
        "HÙNG AN",
        "HÙNG LỢI",
        "HÙNG ĐỨC",
        "HỒ THẦU",
        "HỒNG SƠN",
        "HỒNG THÁI",
        "KHUÔN LÙNG",
        "KHÂU VAI",
        "KIM BÌNH",
        "KIÊN ĐÀI",
        "KIẾN THIẾT",
        "LAO CHẢI",
        "LINH HỒ",
        "LIÊN HIỆP",
        "LÂM BÌNH",
        "LÙNG TÁM",
        "LŨNG CÚ",
        "LŨNG PHÌN",
        "LỰC HÀNH",
        "MINH NGỌC",
        "MINH QUANG",
        "MINH SƠN",
        "MINH THANH",
        "MINH TÂN",
        "MINH XUÂN",
        "MÈO VẠC",
        "MẬU DUỆ",
        "MỸ LÂM",
        "NGHĨA THUẬN",
        "NGỌC LONG",
        "NGỌC ĐƯỜNG",
        "NHỮ KHÊ",
        "NIÊM SƠN",
        "NÀ HANG",
        "NÔNG TIẾN",
        "NẤM DẨN",
        "NẬM DỊCH",
        "PHÙ LƯU",
        "PHÚ LINH",
        "PHÚ LƯƠNG",
        "PHỐ BẢNG",
        "PÀ VẦY SỦ",
        "PỜ LY NGÀI",
        "QUANG BÌNH",
        "QUẢN BẠ",
        "QUẢNG NGUYÊN",
        "SÀ PHÌN",
        "SƠN DƯƠNG",
        "SƠN THUỶ",
        "SƠN VĨ",
        "SỦNG MÁNG",
        "THANH THUỶ",
        "THUẬN HOÀ",
        "THÀNG TÍN",
        "THÁI BÌNH",
        "THÁI HOÀ",
        "THÁI SƠN",
        "THÔNG NGUYÊN",
        "THƯỢNG LÂM",
        "THƯỢNG NÔNG",
        "THƯỢNG SƠN",
        "THẮNG MỐ",
        "TIÊN NGUYÊN",
        "TIÊN YÊN",
        "TRI PHÚ",
        "TRUNG HÀ",
        "TRUNG SƠN",
        "TRUNG THỊNH",
        "TRƯỜNG SINH",
        "TÁT NGÀ",
        "TÂN AN",
        "TÂN LONG",
        "TÂN MỸ",
        "TÂN QUANG",
        "TÂN THANH",
        "TÂN TIẾN",
        "TÂN TRÀO",
        "TÂN TRỊNH",
        "TÙNG BÁ",
        "TÙNG VÀI",
        "VIỆT LÂM",
        "VĨNH TUY",
        "VỊ XUYÊN",
        "XUÂN GIANG",
        "XUÂN VÂN",
        "XÍN MẦN",
        "YÊN CƯỜNG",
        "YÊN HOA",
        "YÊN LẬP",
        "YÊN MINH",
        "YÊN NGUYÊN",
        "YÊN PHÚ",
        "YÊN SƠN",
        "YÊN THÀNH",
        "ĐÔNG THỌ",
        "ĐƯỜNG HỒNG",
        "ĐƯỜNG THƯỢNG",
        "ĐỒNG TÂM",
        "ĐỒNG VĂN",
        "ĐỒNG YÊN",
    ],
    "26": [
        "A LƯỚI 1",
        "A LƯỚI 2",
        "A LƯỚI 3",
        "A LƯỚI 4",
        "A LƯỚI 5",
        "AN CỰU",
        "BÌNH ĐIỀN",
        "CHÂN MÂY - LĂNG CÔ",
        "DƯƠNG NỖ",
        "HOÁ CHÂU",
        "HƯNG LỘC",
        "HƯƠNG AN",
        "HƯƠNG THUỶ",
        "HƯƠNG TRÀ",
        "KHE TRE",
        "KIM LONG",
        "KIM TRÀ",
        "LONG QUẢNG",
        "LỘC AN",
        "MỸ THƯỢNG",
        "PHONG DINH",
        "PHONG PHÚ",
        "PHONG QUẢNG",
        "PHONG THÁI",
        "PHONG ĐIỀN",
        "PHÚ BÀI",
        "PHÚ HỒ",
        "PHÚ LỘC",
        "PHÚ VANG",
        "PHÚ XUÂN",
        "QUẢNG ĐIỀN",
        "THANH THUỶ",
        "THUẬN AN",
        "THUẬN HOÀ",
        "THUẬN HOÁ",
        "THUỶ XUÂN",
        "VINH LỘC",
        "VỸ DẠ",
        "ĐAN ĐIỀN",
    ],
    "44": [
        "AN BIÊN",
        "AN CHÂU",
        "AN CƯ",
        "AN MINH",
        "AN PHÚ",
        "BA CHÚC",
        "BÌNH AN",
        "BÌNH GIANG",
        "BÌNH HOÀ",
        "BÌNH MỸ",
        "BÌNH SƠN",
        "BÌNH THẠNH ĐÔNG",
        "BÌNH ĐỨC",
        "CHI LĂNG",
        "CHÂU PHONG",
        "CHÂU PHÚ",
        "CHÂU THÀNH",
        "CHÂU ĐỐC",
        "CHỢ MỚI",
        "CHỢ VÀM",
        "CÔ TÔ",
        "CÙ LAO GIÊNG",
        "CẦN ĐĂNG",
        "GIANG THÀNH",
        "GIỒNG RIỀNG",
        "GÒ QUAO",
        "HOÀ HƯNG",
        "HOÀ LẠC",
        "HOÀ THUẬN",
        "HOÀ ĐIỀN",
        "HÀ TIÊN",
        "HÒN NGHỆ",
        "HÒN ĐẤT",
        "HỘI AN",
        "KHÁNH BÌNH",
        "KIÊN HẢI",
        "KIÊN LƯƠNG",
        "LONG KIẾN",
        "LONG PHÚ",
        "LONG THẠNH",
        "LONG XUYÊN",
        "LONG ĐIỀN",
        "MỸ HOÀ HƯNG",
        "MỸ THUẬN",
        "MỸ THỚI",
        "MỸ ĐỨC",
        "NGỌC CHÚC",
        "NHƠN HỘI",
        "NHƠN MỸ",
        "NÚI CẤM",
        "PHÚ AN",
        "PHÚ HOÀ",
        "PHÚ HỮU",
        "PHÚ LÂM",
        "PHÚ QUỐC",
        "PHÚ TÂN",
        "RẠCH GIÁ",
        "SƠN HẢI",
        "SƠN KIÊN",
        "THOẠI SƠN",
        "THẠNH HƯNG",
        "THẠNH LỘC",
        "THẠNH MỸ TÂY",
        "THẠNH ĐÔNG",
        "THỔ CHÂU",
        "THỚI SƠN",
        "TIÊN HẢI",
        "TRI TÔN",
        "TÂN AN",
        "TÂN CHÂU",
        "TÂN HIỆP",
        "TÂN HỘI",
        "TÂN THẠNH",
        "TÂY PHÚ",
        "TÂY YÊN",
        "TÔ CHÂU",
        "TỊNH BIÊN",
        "U MINH THƯỢNG",
        "VÂN KHÁNH",
        "VĨNH AN",
        "VĨNH BÌNH",
        "VĨNH GIA",
        "VĨNH HANH",
        "VĨNH HOÀ",
        "VĨNH HOÀ HƯNG",
        "VĨNH HẬU",
        "VĨNH PHONG",
        "VĨNH THUẬN",
        "VĨNH THÔNG",
        "VĨNH THẠNH TRUNG",
        "VĨNH TRẠCH",
        "VĨNH TUY",
        "VĨNH TẾ",
        "VĨNH XƯƠNG",
        "VĨNH ĐIỀU",
        "ÓC EO",
        "Ô LÂM",
        "ĐÔNG HOÀ",
        "ĐÔNG HƯNG",
        "ĐÔNG THÁI",
        "ĐỊNH HOÀ",
        "ĐỊNH MỸ",
    ],
};
